export const API_PARAM = {
  IDENTITY_TENANTS: "core/identity/tenants",
  IDENTITY_CONFIG: "core/identity/config",
  IDENTITY_CURRENT: "core/identity/token",
  IDENTITY_LOGOUT: "core/identity/logout",
  IDENTITY_AVATAR: "core/identity/avatar",
  BASELINE_IDENTITY: "baseline/identity/token",
  NOTIFICATIONS: "notifications",
  NONCE_TOKEN: "core/nonce/token",
  TENANT_SETTINGS: "baseline/tenant-settings",
  BENCHMARK_FILTERING_CONFIG: "baseline/data/benchmark-filterings/config",
  BENCHMARK_FILTERING_DATA: "baseline/data/benchmark-filterings",
  USER_DETAILS: "core/user-details",
  MAINTENANCE: "core/content/maintenance",
  TENANT_CONFIGURATION: "baseline/tenant-configs",
};
